import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useIsLarge, useIsXLarge } from '../../../../../shared/theme';
import useFundsStateStore from '../../../common/funds-state-hook';
import FundTypeCard from './fund-type-card';
import { Button, Clear } from '../common';

const containerStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    border: props => (props.isLarge ? '1px solid #D7DFE7' : 'none'),
    borderRadius: props => (props.isLarge ? 6 : 0),
    height: 'fit-content',
    // eslint-disable-next-line no-nested-ternary
    padding: props => (props.isXLarge ? '48px 48px 40px' : props.isLarge ? '48px 40px 40px' : '40px 0 24px'),
    outline: 'none',
  },
}));

const CardContainer = withStyles(() => ({
  root: {
    display: 'flex',
    flexFlow: 'wrap',
    gap: 12,
    padding: 0,
    outline: 'none',
  },
}))(Container);

const ActionContainer = withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: 32,
    outline: 'none',
    alignItems: 'center',
    marginTop: 32,
    padding: 0,
  },
}))(Container);

const titleStyles = makeStyles(() => ({
  root: {
    fontSize: props => (props.isLarge ? 40 : 21),
    lineHeight: props => (props.isLarge ? '110%' : '120%'),
    fontFamily: 'Texta,Arial,Helvetica,sans-serif',
    fontWeight: props => (props.isLarge ? 400 : 700),
    marginBottom: props => (props.isLarge ? 32 : 24),
  },
}));

export default function Filter() {
  const isLarge = useIsLarge();
  const isXLarge = useIsXLarge();
  const containerClasses = containerStyles({ isLarge, isXLarge });
  const titleClasses = titleStyles({ isLarge });
  const set = useFundsStateStore(state => state.set);
  const fundTypes = useFundsStateStore(state => state.filters.fundTypes);

  const clear = () => {
    set(state => {
      state.filters.fundTypes = [];
    });
  };

  const apply = () => {
    set(state => {
      state.filterChanged = fundTypes !== state.appliedFilters.fundTypes;
      state.appliedFilters.fundTypes = fundTypes;
      state.showFundTypesModal = false;
    });
    sessionStorage.setItem('userChangedFilterCondition', 'true');
  };

  return (
    <Container className={containerClasses.root}>
      <Typography className={titleClasses.root}>Filter by Investment Type</Typography>
      <CardContainer>
        <FundTypeCard
          activeBgColor="#F5F9FF"
          typeColor="#2563EB"
          typeBgColor="#DBEAFE"
          type="managed-funds"
          label="managed fund"
          description="In a managed fund, your money is pooled together with other investors’ money. The fund manager then uses this pool of money to buy and sell shares (and other assets)."
        />
        <FundTypeCard
          activeBgColor="#F6FEFA"
          typeColor="#047857"
          typeBgColor="#D1FAE5"
          type="etfs"
          label="etf"
          description="An exchange-traded fund, or ETF, is a collection of investments that track the performance of a specific market index. Actively managed ETFs are also available."
        />
        <FundTypeCard
          activeBgColor="#F7F5FF"
          typeColor="#6D28D9"
          typeBgColor="#EDE9FE"
          type="lics"
          label="lic"
          description="Listed Investment Companies like managed funds are actively managed. Unlike managed funds, LICs list and trade on the ASX."
        />
        <FundTypeCard
          activeBgColor="#FEFAFF"
          typeColor="#A21CAF"
          typeBgColor="#FAE8FF"
          type="lits"
          label="lit"
          description="Listed Investment Trust, like managed funds, are actively managed. LITs distribute all net income and realised capital gains to investors are on a pre-tax basis."
        />
      </CardContainer>
      {isLarge && (
        <ActionContainer>
          <Button onClick={apply}>Apply</Button>
          <Clear className={fundTypes.length > 0 ? 'active' : ''} onClick={clear}>Clear</Clear>
        </ActionContainer>
      )}
    </Container>
  );
}
